@if (activeUser.isLoggedIn()) {
  <p-avatar
    class="cursor-pointer"
    [label]="activeUser.userChar()"
    [styleClass]="styleClass"
    [size]="size"
    (click)="menu.toggle($event)"
    shape="circle"></p-avatar>
  <p-menu
    styleClass="max-h-22rem w-16rem overflow-auto right-0 left-auto"
    #menu
    [model]="menuItems"
    [popup]="true">
    <ng-template pTemplate="submenuheader" let-item>
      <span class="text-color-secondary flex gap-3 align-items-center"
        ><i [class]="item.icon"></i>{{ item.label }}</span
      >
    </ng-template>
  </p-menu>
}
